"use client";

import React, { Suspense } from "react";
import { useRouter } from "next/navigation";
import Company from "@/components/CompanyDetailForm";
import { useAuth } from "@/store/auth";
import { X } from "lucide-react";

const CompanyPage = () => {
  const router = useRouter();
  const auth = useAuth();

  const handleClose = () => {
    if (auth?.token || auth?.user?.id) {
      router.push("/dashboard");
    } else {
      router.push("/login");
    }
  };

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {/* Modal Overlay */}
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-[#00000090] px-4">
        {/* Modal Container */}
        <div className="w-[640px] bg-white rounded-xl shadow-2xl relative flex flex-col max-h-[90vh]">
          {/* Header */}
          <div className="border-b border-gray-300 py-4 px-6">
            <div className="flex items-center justify-between shrink-0">
              <h2 className="text-lg font-semibold text-gray-900">
                Company Details
              </h2>

              <button
                onClick={handleClose}
                className="text-gray-500 hover:text-black transition cursor-pointer"
                aria-label="Close"
              >
                <X size={22} />
              </button>
            </div>
            <p className="text-xs text-gray-600">
              Please fill the details below.
            </p>
          </div>
          {/* Scrollable Content */}
          <div className="flex-1 p-6 overflow-y-auto">
            <Company />
          </div>
        </div>
      </div>
    </Suspense>
  );
};

export default CompanyPage;
